import React from 'react';
import { 
	string, 
	object,
	oneOfType,
	func
} from 'prop-types';
import '../../../i18n';
import { withNamespaces } from 'react-i18next';
import style from './style';

const ErrorContent = ({message, detail, t, className}) => {
	return (
		<style.Wrapper className={className}>
			<h1>
				<span role='img' aria-label='caution'>⚠️</span> {t('error.Header')}
			</h1>
			<div>
				<style.Label>{t('error.Message')}</style.Label>
			</div>
			<style.P>
				{typeof(message) === 'object' ? message.toString() : message}
			</style.P>
			<div>
				<style.Label>{t('error.Detail')}</style.Label>
			</div>
			<style.P>
				{typeof(detail) === 'object' ? detail.toString() : detail}
			</style.P>
		</style.Wrapper>
	);
};

ErrorContent.propTypes = {
	message : string.isRequired,
	detail : oneOfType([string,object]),
	t : func.isRequired,
	className : string
};

export default withNamespaces()(ErrorContent);